import PropTypes from 'prop-types'
import { useAuth } from './AuthContext'
import { Navigate } from 'react-router-dom'
import { isSystemAdmin } from 'constants/roles'

export const SYSTEM_HOME = '/system/tenants'
export const TENANT_HOME = '/dashboard'

// scope: 'tenant' = farm screens (the system admin has no farm, so it is sent to
// System); 'system' = system admin only; 'any' = every authenticated user.
const ProtectedRoute = ({ children, requiredPermission = null, scope = 'any' }) => {
  const { user } = useAuth()

  if (!user) {
    return <Navigate to='/login' replace />
  }

  const systemAdmin = isSystemAdmin(user)
  if (scope === 'tenant' && systemAdmin) {
    return <Navigate to={SYSTEM_HOME} replace />
  }
  if (scope === 'system' && !systemAdmin) {
    return <Navigate to={TENANT_HOME} replace />
  }

  if (requiredPermission && !user.permissions?.includes(requiredPermission)) {
    return <Navigate to='/dashboard' replace />
  }

  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.number,
  scope: PropTypes.oneOf(['any', 'tenant', 'system'])
}

export default ProtectedRoute
